import React from 'react';
import { useSelector } from 'react-redux';
import { Avatar } from 'app/components/external';

import { dom } from 'app/utils';
import { getUser } from 'app/state';
import { Icon } from '../../components/common';

export default function Profile() {
  const user = useSelector(getUser);

  return (
    <div className="h-full grid grid-nogutter">
      <div className="col-3 px-5 py-8 surface-200 text-center">
        <Avatar icon={<Icon name="mdi-person" size="xl" />} size="xlarge" shape="circle" className={dom.className('mb-4', 'p-7', 'text-6xl', 'surface-100')} />
        <div className="text-xl font-semibold">{ user?.username ?? 'Guest' }</div>
      </div>
      <div className="col-9 overflow-auto">

      </div>
    </div>
  );
}
